import axios from 'src/utils/axios';
import { getUser, setRoleSession } from 'src/utils/Common';

// Yetkiler login'de okunur (layouts/Auth). Kullanıcı kendi yetkisini değiştirdiğinde F5 gerektirmeden yeniden okunur.
// Başka kullanıcıların değişiklikleri eskisi gibi F5 / yeniden giriş ile yansır.
export const ROLES_UPDATED_EVENT = 'dia:roles-updated';

const getSessionSicil = () => {
  const user = getUser();
  return user && typeof user === 'object' ? user.UserId : null;
};

// Düzenlenen kayıt oturumdaki kullanıcıya mı ait
export const isSessionUser = (sicil) => {
  const sessionSicil = getSessionSicil();
  return !!sessionSicil && !!sicil && String(sicil).trim().toLocaleUpperCase('tr-TR') === String(sessionSicil).trim().toLocaleUpperCase('tr-TR');
};

export const refreshUserRoles = () => {
  const sicil = getSessionSicil();
  if (!sicil) return Promise.resolve(false);

  return axios
    .get('/GetUserRoles/' + sicil, { headers: { 'Content-Type': 'application/json' } })
    .then((response) => {
      const roles = response?.data?.[0];
      if (!roles) return false;
      setRoleSession(roles);
      window.dispatchEvent(new Event(ROLES_UPDATED_EVENT));
      return true;
    })
    .catch(() => false);
};
